import { AuditTimeline } from '../../components/AuditTimeline';
import { useHistory } from '../../components/use-history';
import { TruckStatusHistory } from './TruckStatusHistory';
import type { TruckStatusHistoryEntry } from './trucks.api';

/**
 * A truck's whole history: status moves (gitaumoses4/chukua#19) above the general audit
 * trail — field edits, odometer readings and document changes, all audited against `entityType: 'truck'`.
 */
export function TruckHistoryTab({ truckId, statusHistory }: { truckId: string; statusHistory: TruckStatusHistoryEntry[] }) {
  const state = useHistory('truck', truckId, true);
  return (
    <div className="flex flex-col gap-8">
      <TruckStatusHistory entries={statusHistory} />
      <AuditTimeline state={state} />
    </div>
  );
}
